import {
  VuexModule, Module, Mutation, Action, getModule,
} from 'vuex-module-decorators';
// import { setLanguage } from '@/plugins/cookies';
import store from '@/store';
import { getCountries } from '@/api/Language';
// eslint-disable-next-line import/named
import { getPortalJobCount, getPortalSetting } from '@/api/Setting';
import { getTranslationData, getTranslationTextData, settingsItems } from '@/api/Translation';
import { translationsIds, translationTextIds } from '@/config/translations';
import { JobType } from '@/types/ProfessionType';
import { getCompanyClustersCount } from '@/api/Clusters';

export interface IAppState {
  language: string
  country: any
  translation: object
  translationText: object
  languageSid: string
  sid: string
  setting: any
  settingPortal: {
    applicant_fields_disabled: any[]
    clusters: any[]
    header_image: any
    header_image_text: any
    info_bars: any[]
    occupational_cluster_text: any
  }
  isRegistrationTab: boolean
  privacy: boolean
  visibleMap: boolean
  visibleJobs: boolean
  visibleClusterJobs: boolean
  visibleCompany: boolean
  jobCountPortal: { clusters: { id: number, count: number}[] }
  companyCountPortal: { clusters: { id: number, count: number}[] }
}

@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements IAppState {
  public language = 'de';

  public translation = {} as any;

  public translationText = {} as any;

  public sid = 'l4a';

  public languageSid = 'l4a';

  public country = [] as any;

  public setting = {} as any;

  public settingPortal = {
    applicant_fields_disabled: [],
    clusters: [],
    header_image: null,
    header_image_text: null,
    info_bars: [],
    occupational_cluster_text: null,
  } as any;

  public isRegistrationTab = false;

  public jobCountPortal = {
    clusters: [],
  }

  public companyCountPortal = {
    clusters: [],
  }

  public privacy = false;

  visibleMap = false

  visibleJobs = false

  visibleClusterJobs = false

  visibleCompany = false

  isIframe = false;

  get getLanguage(): string {
    return this.language;
  }

  // Mutation
  @Mutation
  private SET_PRIVACY(payload: boolean) {
    this.privacy = payload;
  }

  @Mutation
  private SET_IS_IFRAME(payload: boolean) {
    this.isIframe = payload;
  }

  // Mutation
  @Mutation
  private SET_PORTAL_JOB_COUNT(payload: any) {
    this.jobCountPortal = payload;
  }

  @Mutation
  private SET_PORTAL_COMPANY_COUNT(payload: any) {
    this.companyCountPortal = payload;
  }

  @Mutation
  private SET_COUNTRY(language: any) {
    this.country = language;
  }

  @Mutation
  SET_REGISTRATION_TAB(value: IAppState['isRegistrationTab']) {
    this.isRegistrationTab = value;
  }

  @Mutation
  private SET_LANGUAGE(language: string) {
    this.language = language;
  }

  @Mutation
  private SET_TRANSLATION(data: any) {
    this.translation = data;
  }

  @Mutation
  private SET_TRANSLATION_TEXTS(data: any) {
    this.translationText = data;
  }

  @Mutation
  private SET_SID(request: any) {
    this.sid = request;
  }

  @Mutation
  private SET_LANGUAGE_SID(request: any) {
    this.languageSid = request;
  }

  @Mutation
  private SET_SETTING(request: any) {
    this.setting = request;
  }

  @Mutation
  private SET_SETTING_PORTAL(request: any) {
    this.settingPortal = request;
  }

  @Mutation
  private SET_VISIBLE_MAP(payload: any) {
    this.visibleMap = payload;
  }

  @Mutation
  private SET_VISIBLE_CLUSTER_JOBS(payload: any) {
    this.visibleClusterJobs = payload;
  }

  @Mutation
  private SET_VISIBLE_JOBS(payload: any) {
    this.visibleJobs = payload;
  }

  @Mutation
  private SET_VISIBLE_COMPANY(payload: any) {
    this.visibleCompany = payload;
  }

  @Action
  SetVisibleCompany(payload: boolean) {
    this.SET_VISIBLE_COMPANY(payload);
  }

  @Action
  SetVisibleMap(payload: boolean) {
    this.SET_VISIBLE_MAP(payload);
  }

  @Action
  SetVisibleJobs(payload: boolean) {
    this.SET_VISIBLE_JOBS(payload);
  }

  @Action
  SetVisibleClusterJobs(payload: boolean) {
    this.SET_VISIBLE_CLUSTER_JOBS(payload);
  }

  @Action
  public setPrivacy(payload: boolean) {
    this.SET_PRIVACY(payload);
  }

  @Action
  public ActionSid(sid: string) {
    if (sid) {
      const language = sid.split('_');
      this.SET_SID(sid);
      // this.SET_SID(language[0]);
    }
  }

  @Action
  public ActionLanguageSid(sid: string) {
    this.SET_LANGUAGE_SID(sid);
  }

  @Action
  async getTranslation() {
    const strings = await getTranslationData({ lang: this.language, ids: translationsIds });
    this.SET_TRANSLATION(strings);
  }

  @Action
  async getTranslationText() {
    const resp = await getTranslationTextData({ lang: this.language, ids: translationTextIds });
    this.SET_TRANSLATION_TEXTS(resp);
  }

  @Action({ rawError: true })
  async ActionCountry(params: any): Promise<void> {
    try {
      const request = await getCountries(params);
      this.SET_COUNTRY(request);
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      throw error;
    }
  }

  @Action
  public ActionLanguage(lang: string) {
    this.SET_LANGUAGE(lang);
    if (lang !== 'de') {
      this.SET_LANGUAGE_SID(`${this.sid}_${lang}`);
      this.SET_SID(`${this.sid}_${lang}`);
    } else {
      this.SET_LANGUAGE_SID(`${this.sid}`);
      this.SET_SID(`${this.sid}`);
    }
  }

  @Action({ rawError: true })
  async getSetting(params: any): Promise<void> {
    try {
      const request = await settingsItems(params);
      this.SET_SETTING(request);
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      throw error;
    }
  }

  @Action({ rawError: true })
  async getSettingPortal(params: any): Promise<void> {
    try {
      const request = await getPortalSetting(params);
      this.SET_SETTING_PORTAL(request);
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
    }
  }

  @Action({ rawError: true })
  async getJobCountPortal(params: any): Promise<void> {
    try {
      const request = await getPortalJobCount(params);
      this.SET_PORTAL_JOB_COUNT(request);
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
    }
  }

  @Action({ rawError: true })
  async GetCompanyCountPortal(payload: any) {
    const params = {
      ...payload,
    };
    const request = await getCompanyClustersCount(params);
    this.SET_PORTAL_COMPANY_COUNT(request);
  }

  @Action
  public SetIsIframe(payload: boolean) {
    this.SET_IS_IFRAME(payload);
  }
}

export const AppModule = getModule(App);
